import React from 'react';
import { Modal } from '../../components/feedback/modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/pro-light-svg-icons';
import { AlertButton, SecondaryButton } from '../../components/display/button';

type Props = {
  onConfirm: () => void;
  open: boolean;
  setOpen: (isOpen: boolean) => void;
  names: string[];
  spendAmount?: number;
};
export function MediaPlansDeleteModal({ open, setOpen, onConfirm, names, spendAmount }: Props) {
  return (
    <Modal
      open={open}
      setOpen={setOpen}
      header={
        <div className="flex flex-col gap-3 rounded-t-2xl bg-red-100 py-6 text-center text-2xl font-semibold text-red-600">
          <FontAwesomeIcon icon={faTrashCan} />
          Are you sure you want to delete?
        </div>
      }
      content={
        <div className="p-4 text-sm text-gray-700">
          <DeleteMessage names={names} />
          {spendAmount != null && spendAmount > 0 ? (
            <div className="mt-3 rounded bg-amber-50 p-3 text-amber-800">
              This media plan has{' '}
              <span className="font-semibold">
                $
                {spendAmount.toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
              </span>{' '}
              in recorded spend.
            </div>
          ) : null}
        </div>
      }
      footer={
        <Footer
          onConfirm={onConfirm}
          onClose={() => setOpen(false)}
          confirmLabel="Confirm delete"
        />
      }
    />
  );
}

function DeleteMessage({ names }: { names: string[] }) {
  return (
    <div>
      <div className="font-semibold">
        {names.length > 1 ? `Delete ${names.length} Media Plans` : `Delete Media Plan: ${names[0]}`}
      </div>
      {names.length > 1 && names.length < 10 && (
        <ul className="list-disc pl-6">
          {names.map((name, idx) => (
            <li key={idx}>{name}</li>
          ))}
        </ul>
      )}
      <div>Confirm you want to delete this Media Plan</div>
    </div>
  );
}

type FooterProps = {
  onConfirm: () => void;
  confirmLabel: string;
  onClose: () => void;
};

function Footer({ onConfirm, confirmLabel, onClose }: FooterProps) {
  return (
    <div className="flex gap-4 p-4">
      <SecondaryButton className="grow justify-around" onClick={onClose}>
        Cancel
      </SecondaryButton>
      <AlertButton className="grow justify-around" onClick={onConfirm}>
        {confirmLabel}
      </AlertButton>
    </div>
  );
}
